import { Switch } from "@headlessui/react";
import { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { object, boolean } from 'yup';
import { classNames } from "../tools/ClassNames"
const SeleccionOpcion = ({ handleContinuar }) => {
  const [filterR, setFilterR] = useState(false);
  const [filterR1, setFilterR1] = useState(false);

  const handleFilterR = (
    setFieldValue,
    errors,
    values,
    setErrors,
    validateForm
  ) => {
    if (filterR === true || filterR1 === true) {
      try {
        //setErrors({})
        validateForm();
      } catch (e) {
        console.log(e);
      }
    } else {
      validateForm();
    }

    setFilterR(!filterR);
    setFieldValue("op1", !filterR);
    //filterR === true ? setAlmenosUno(true):setAlmenosUno(false)

    if (!filterR) {
      if (filterR === true || filterR1 === true) {
        try {
          // setErrors({})
          validateForm();
        } catch (e) {
          console.log(e);
        }
      } else {
        validateForm();
      }
      //filterR === true ? setAlmenosUno(true):setAlmenosUno(false)
      setFilterR1(false);
      setFieldValue("op2", false);
    }
  };

  const handleFilterR1 = (
    setFieldValue,
    errors,
    values,
    setErrors,
    validateForm
  ) => {
    //setAlmenosUno(setErrors)
    //setErrors({})
    if (filterR === true || filterR1 === true) {
      try {
        //setErrors({})
        validateForm();
      } catch (e) {
        console.log(e);
      }
    }
    setFilterR1(!filterR1);
    setFieldValue("op2", !filterR1);
    //filterR1 === true ? setAlmenosUno(true):setAlmenosUno(false)
    //errors={}
    if (!filterR1) {
      //filterR1 === true ? setAlmenosUno(true):setAlmenosUno(false)
      if (filterR === true || filterR1 === true) {
        try {
          //setErrors({})
          validateForm();
        } catch (e) {
          console.log(e);
        }
      }
      //setAlmenosUno(false)
      setFilterR(false);
      setFieldValue("op1", false);
    }
  };
  useEffect(() => {}, []);

  const initialValues = {
    op1: false,
    op2: false,
  };

  const validationSchema = object().shape({
    op1:
      filterR1 === false && filterR === false
        ? 
            boolean()
            .required()
            .test("OP2_VALID", "", (value, context) => {
              if (!context.parent.op2 === false && !value === false) {
                return false;
              } else {
                return true;
              }
            })
        : null,
    op2:
      filterR1 === false && filterR === false
        ? 
            boolean()
            .required()
            .test("OP1_VALID", "", (value, context) => {
              if (context.parent.op1 === false && value === false) {
                return false;
              } else {
                return true;
              }
            })
        : null,
  });

  const handleSubmit = (values) => {
    if (values.op1) {
      handleContinuar("contrasena");
    } else {
      handleContinuar("usuario");
    }
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({
          setFieldValue,
          values,
          resetForm,
          errors,
          touched,
          setErrors,
          validateForm,
        }) => {
          return (
            <Form>
              <label className="ml-5 font-bold text-white text-lg">
                ¿No puedes iniciar sesión?
              </label>
              <div className="px-4 mt-4 flex">
                <div className="py-1 flex-2">
                  <Switch
                    id="op1"
                    name="op1"
                    checked={filterR}
                    onChange={() =>
                      handleFilterR(
                        setFieldValue,
                        errors,
                        values,
                        setErrors,
                        validateForm
                      )
                    }
                    className="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-secundario focus:ring-offset-2"
                  >
                    <span className="sr-only">Use setting</span>
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute h-full w-full rounded-md bg-white"
                    />
                    <span
                      aria-hidden="true"
                      className={classNames(
                        filterR ? "bg-secundario" : "bg-gray-200",
                        "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
                      )}
                    />
                    <span
                      aria-hidden="true"
                      className={classNames(
                        filterR ? "translate-x-5" : "translate-x-0",
                        "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
                      )}
                    />
                  </Switch>
                </div>
                <div className="px-2 flex-2">
                  <p className="font-bold text-white text-base">
                    He olvidado mi contraseña.
                  </p>
                </div>
              </div>
              <div className="px-4 mt-1 flex">
                <div className="py-1 flex-2">
                  <Switch
                    id="op2"
                    name="op2"
                    checked={filterR1}
                    onChange={() =>
                      handleFilterR1(
                        setFieldValue,
                        errors,
                        values,
                        setErrors,
                        validateForm
                      )
                    }
                    className="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-secundario focus:ring-offset-2"
                  >
                    <span className="sr-only">Use setting</span>
                    <span
                      aria-hidden="true"
                      className="pointer-events-none absolute h-full w-full rounded-md bg-white"
                    />
                    <span
                      aria-hidden="true"
                      className={classNames(
                        filterR1 ? "bg-secundario" : "bg-gray-200",
                        "pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out"
                      )}
                    />
                    <span
                      aria-hidden="true"
                      className={classNames(
                        filterR1 ? "translate-x-5" : "translate-x-0",
                        "pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out"
                      )}
                    />
                  </Switch>
                </div>
                <div className="px-2 flex-2">
                  <p className="font-bold text-white text-base">
                    He olvidado mi nombre de usuario.
                  </p>
                </div>
              </div>
              {Object.values(errors).length > 0 ? (
                filterR === false && filterR1 === false ? (
                  <p className="col-span-full w-full text-center block text-sm font-semibold text-red-500">
                    Selecciona una opción de recuperación válida
                  </p>
                ) : null
              ) : null}

              <div className="m-2 flex flex-row text-center">
                <a
                  className="w-full mt-8 m-2 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
                  href="/campus/login"
                >
                  Atrás
                </a>
                <button
                  className="w-full mt-8 m-2 px-6 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500 ease text-white rounded-lg"
                  type="submit"
                >
                  Continuar
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default SeleccionOpcion;
